import {useQuery} from 'react-query';
import {usStatesQueryKey} from 'constants/query';
import UsStatesApi from 'api/us-states-api';

export function useUSStatesQuery() {
  return useQuery(usStatesQueryKey, () => UsStatesApi.getUSStates());
}
